<button
  class="download-button"
  attr.aria-label="{{ 'export.downloadButton.excelAlt' | transloco }}"
  [disabled]="this.buttonDisable"
  [matTooltip]="'export.downloadButton.toolTip' | transloco"
  (click)="downloadItemsSummary()">
  <mat-icon>download</mat-icon>
</button>
